import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c83fb214"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "modal-title" }, "Add Signage Lists to Layout", -1))
const _hoisted_2 = { class: "modal-subtitle" }
const _hoisted_3 = { class: "dt-card__body" }
const _hoisted_4 = { class: "list-wrapper pool" }
const _hoisted_5 = {
  key: 0,
  class: "dt-list"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "dt-list__title" }
const _hoisted_8 = {
  class: "dt-icon",
  viewBox: "0 0 24 24"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M9,20.42L2.79,14.21L5.62,11.38L9,14.77L18.88,4.88L21.71,7.71L9,20.42Z" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 0,
  class: "no-list-search-results"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "No lists match search", -1))
const _hoisted_14 = {
  key: 1,
  class: "empty-message"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "No signage lists available.", -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "divider" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "dt-icon",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M21,9L17,5V8H10V10H17V13M7,11L3,15L7,19V16H14V14H7V11Z" })
  ])
], -1))
const _hoisted_18 = { class: "list-wrapper active" }
const _hoisted_19 = {
  key: 0,
  class: "dt-list active"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "dt-list__title" }
const _hoisted_22 = {
  key: 0,
  class: "no-list-search-results"
}
const _hoisted_23 = ["src"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "No lists match search", -1))
const _hoisted_25 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": _ctx.visible,
    "custom-class": "signage-list-assignment-modal",
    width: "70%",
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('modal-closed'))),
    "before-close": _ctx.handleClose
  }, {
    title: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.layoutName), 1)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_25, [
        _createVNode(_component_el_button, { onClick: _ctx.handleClose }, {
          default: _withCtx(() => [
            _createTextVNode("Cancel")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          onClick: _ctx.onSave
        }, {
          default: _withCtx(() => [
            _createTextVNode("Save")
          ]),
          _: 1
        }, 8, ["onClick"])), [
          [_directive_loading, _ctx.loading]
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("article", _hoisted_4, [
          _createVNode(_component_el_input, {
            placeholder: "Search signage lists",
            modelValue: _ctx.availableListsFilter,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.availableListsFilter) = $event)),
            clearable: ""
          }, null, 8, ["modelValue"]),
          (_ctx.filteredAvailableLists && _ctx.filteredAvailableLists.length)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredAvailableLists, (list) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: list.id,
                    class: _normalizeClass([{ added: list.taken }, "dt-list__item"]),
                    onClick: ($event: any) => (_ctx.listPoolClick(list))
                  }, [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(list.name), 1),
                    _withDirectives((_openBlock(), _createElementBlock("svg", _hoisted_8, _hoisted_10, 512)), [
                      [_vShow, list.taken]
                    ])
                  ], 10, _hoisted_6))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_ctx.availableListsFilter)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("img", {
                        src: require('../../assets/images/Whats-Mirroring.png')
                      }, null, 8, _hoisted_12),
                      _hoisted_13
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
              ], 64))
        ]),
        _hoisted_17,
        _createElementVNode("article", _hoisted_18, [
          _createVNode(_component_el_input, {
            placeholder: "Search signage lists",
            modelValue: _ctx.selectedListFilter,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedListFilter) = $event)),
            clearable: ""
          }, null, 8, ["modelValue"]),
          (_ctx.filteredSelectedList && _ctx.filteredSelectedList.length)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_19, [
                _createVNode(_TransitionGroup, { name: "swap-list" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredSelectedList, (list) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: list.id,
                        onClick: ($event: any) => (_ctx.selectedListClickHandler(list)),
                        class: "dt-list__item"
                      }, [
                        _createElementVNode("span", _hoisted_21, _toDisplayString(list.name), 1)
                      ], 8, _hoisted_20))
                    }), 128))
                  ]),
                  _: 1
                })
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_ctx.selectedListFilter)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createElementVNode("img", {
                        src: require('../../assets/images/Whats-Mirroring.png')
                      }, null, 8, _hoisted_23),
                      _hoisted_24
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value", "before-close"]))
}